import { useGetRolesForUser } from "./useGetRolesForUser";

interface IRolesValidation {
  isEngagementValid: boolean;
  hasPrimaryRole: boolean;
}

const useRolesValidation = (userId: string | undefined): IRolesValidation => {
  const { data: roles } = useGetRolesForUser(userId);
  const totalEngagement = roles?.reduce((sum, role) => sum + role.engagementPercentage, 0) ?? 0;
  return {
    isEngagementValid: !roles?.length || totalEngagement === 100,
    hasPrimaryRole: !roles?.length || roles.some((role) => role.isPrimaryRole),
  };
};

export { useRolesValidation };
